import { pick } from 'lodash';
import React, { useCallback, useEffect } from 'react';
import { createFilter } from '../../../../../../data/filters/schedule/createFilter/createFilter';
import { useScheduleFilter } from '../../../../../../data/hooks/schedule/useScheduleFilter';
import FilteredScheduleTabContent from '../common/FilteredScheduleTabContent/FilteredScheduleTabContent';

function ScheduleTagged(props) {
    const { event, dateFilter, focusedRoundId } = props,
        [fullFilter, hasFilter] = useScheduleFilter(event.id),
        filter = useCallback(createFilter(pick(fullFilter, ['categories'])), [fullFilter]);

    useEffect(() => {
        if (!hasFilter) {
            app.history.push('..');
        }
    }, [hasFilter]);

    return <FilteredScheduleTabContent event={event} filter={filter} dateFilter={dateFilter} focusedRoundId={focusedRoundId} />;
}

export default (props) => {
    const { event } = props;
    return <ScheduleTagged {...props} />;
};
